enum AppHeaders {
  AdminToken = 'X-Admin-Token',
}

export default AppHeaders;
